interface User {
    user_id: number;
    email: string;
    is_study_participant: boolean;
  }
  
  export class LoginService {
    static handleGuestLogin(): User {
      const user = {
        user_id: 166, // Default ID for guest
        email: 'guest', // Default email for guest
        is_study_participant: false, // Default study participant status
      };
  
      const session_id = localStorage.getItem('session_id') || crypto.randomUUID();
      localStorage.setItem('session_id', session_id);
      
      const is_study_participant = localStorage.getItem('is_study_participant');
      
      return user;
    }
  } 